/*!
* @alife/cn-uni-api v2.10.0
* (c) Alibaba Group Holding Limited.
*
* @license ISC
* @build at 2023/8/21 10:19:44
*/
function snapshot(options, context) {
    var _a;
    // https://yuque.alibaba-inc.com/dingtalk-miniprogram/api/bxvy5t
    var api = 'dd.biz.conference.screenshot';
    (_a = context === null || context === void 0 ? void 0 : context.DDCall) === null || _a === void 0 ? void 0 : _a.call(context, api, options);
}

export { snapshot as default };
